import { render, staticRenderFns } from "./DashboardDesigns.vue?vue&type=template&id=aa209cde&scoped=true&"
import script from "./DashboardDesigns.vue?vue&type=script&lang=js&"
export * from "./DashboardDesigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa209cde",
  null
  
)

export default component.exports